import { itemOfferChoices, declinedItemStatuses } from 'constants/leadStatuses';

/**
 * The one place a payout selection is derived, so what the dropdown shows and what
 * the submission carries cannot drift apart. Nothing is pre-selected: an item is
 * answered only by the seller's own pick or a choice already stored against it.
 */
export const getItemSelection = (item, itemSelections) => {
  const chosen = itemSelections?.[item.id];

  if (chosen) {
    return chosen;
  }

  if (declinedItemStatuses.includes(item.status)) {
    return itemOfferChoices.DECLINE;
  }

  if (item.consignment === true) {
    return itemOfferChoices.CONSIGNMENT;
  }

  if (item.consignment === false) {
    return itemOfferChoices.CASH;
  }

  return null;
};
